export const USER_ADMIN = 'admin'
export const ADMIN_PASSWORD = '1128265638Medellin.'